<template>
  <LoadingScreen
    v-if="showBlockingLoadingScreen"
    :error-message="loadingErrorMessage"
  />
  <div v-else id="app">
    <template v-if="configVals && navless">
      <RouterView
        :key="configVals.apiUrl"
        class="h-px flex-1"
        :class="pageClasses"
      />
    </template>
    <template v-else-if="configVals">
      <!--
        Wrapped navbar/banners to measure height so toasts sit clear
        See useToastTopOffset.

        CLEANUP(MET-2986): keep only the wrapped arm and drop the flag check.
        Both arms must render the same chrome children— add to both or neither.
      -->
      <div
        v-if="showScheduledCallsToast"
        ref="appChrome"
        data-testid="app-chrome"
      >
        <TWarningBanner />
        <SoftphoneWindowManager v-if="showAmazonCCP" />
        <TopNavBar v-if="showNavBar" class="print:hidden print-hidden" />
      </div>
      <template v-else>
        <TWarningBanner />
        <SoftphoneWindowManager v-if="showAmazonCCP" />
        <TopNavBar v-if="showNavBar" class="print:hidden print-hidden" />
      </template>

      <!-- using the apiUrl as the key reloads the page on change -->
      <RouterView
        :key="configVals.apiUrl"
        class="h-px flex-1"
        :class="pageClasses"
      />
      <AmazonConnectGlobalWrapper />
      <RestrictedDialModal />
      <TutorialLauncher v-if="enableTutorials" :configs="wizardConfigs" />
      <!--
        CLEANUP(MET-2986): drop the flag check, keep the mount.
      -->
      <TToast v-if="showScheduledCallsToast" @close="dismissCallReminder" />
    </template>
    <ErrorPage v-else class="page" :message="errorMessage" />
  </div>
</template>

<script lang="ts">
import TToast from '@thyme/nashville/src/components/toast/TToast.vue'
import { defineAsyncComponent, defineComponent } from 'vue'
import { RouterView } from 'vue-router'
import TopNavBar from '@/legacy/components/TopNavBar/TopNavBar.vue'
import TWarningBanner from '@/legacy/nashville/menu/TWarningBanner/TWarningBanner.vue'
import RestrictedDialModal from '@/libs/features/phoneNumbers/RestrictedDialModal/RestrictedDialModal.vue'
import ErrorPage from '@/pages/Basic/ErrorPage/ErrorPage.vue'
import LoadingScreen from '@/pages/Basic/LoadingScreen/LoadingScreen.vue'
import { setup } from './controller'

export default defineComponent({
  components: {
    TToast,
    TopNavBar,
    TWarningBanner,
    RouterView,
    LoadingScreen,
    ErrorPage,
    RestrictedDialModal,
    AmazonConnectGlobalWrapper: defineAsyncComponent(
      () => import('@/tokens/amazonCCP/AmazonConnectGlobalWrapper.vue')
    ),
    SoftphoneWindowManager: defineAsyncComponent(
      () =>
        import('@/tokens/amazonCCP/SoftphoneWindowManager/SoftphoneWindowManager.vue')
    ),
    TutorialLauncher: defineAsyncComponent(
      () =>
        import('@thyme/nashville/src/components/thymeWizard/TutorialLauncher/TutorialLauncher.vue')
    ),
  },
  setup,
})
</script>

<style scoped lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  @apply h-screen w-screen flex-col flex justify-stretch;
  // Old Browsers & Firefox
  height: 100vh;
  // Modern Browsers & Mobile
  // Fixes browser height issue on mobile
  // https://stackoverflow.com/a/70048720
  height: 100dvh;
}
</style>
